import React, { useState, useEffect, useRef } from 'react';
import TablaPedidos from './tablaPedidos';
import { Line } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import CartasClientes from './cartas/cartas';

const PanelPedidos = (props) => {

    const [vista, setVista] = useState('panel')
  

    const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Chart.js Line Chart',
        },
    },
    };
    const data = {
    labels: labels,
    datasets: [
        {
            label: 'Recaudado',
            data: ["565", "258", "705", "528", "451", "359", "912", "125", "258", "348", "585", "706"],
            borderColor: 'rgb(255, 99, 132)',

        },
        {
            label: 'Meta Presupuestaria',
            data: ["455", "455", "455", "455", "455", "455", "455", "455", "455", "455", "455", "455"],
            borderColor: 'rgb(2, 99, 132)',

        }
    ],
    };

    const optionss = {
    plugins: {
        title: {
            display: true,
            text: 'Chart.js Bar Chart - Stacked',
        },
    },
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
    };

    const labelss = ['Timbres Fiscales', 'Impuesto 1x500', 'Impuesto Minas', 'Impuesto Producción'];
    const labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    const datas = {
    labels: labelss,
    datasets: [
        {
            label: 'Meta Presupuestaria',
            data: ["9", "7", "5", "6"],
            backgroundColor: 'rgba(53, 162, 235)',
            stack: 'Stack 1',
        },
        {
            label: 'Recaudado',
            data: ["7", "4", "9", "7"],
            backgroundColor: 'rgba(255, 99, 132)',
            stack: 'Stack 2',
        },
    ],
    };

    useEffect(() => {

    }, []);

  

  return (
    <div style={{ height: '100%', width: '100%' }}>
        {
            /* vista === 'panel' ?
            
            <div className='col-md-12 py-5 row mx-auto'>
                <div className='col-md-8 row- row mx-auto card py-4 px-3 shadow' >
                   
                    <CartasClientes/>
                    <div className='co-md-12 row mx-auto justify-content-end mb-2 px-4'>
                        <button type="button" onClick={() => {setVista('tabla')}} style={{ height: '27px' }}  class="btn btn-sm col-md-2 rounded-pill btn-primary"><i style={{ fontSize: '9px' }} class="fas fa-plus">Generar Pedido</i></button>
                    </div>
                    <div className='row'>
                        <div className="col-md-6 h-25">
                            <div className="row py-0 my-0 m-0">
                                <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>Ingreso General</h5>
                                <hr className='w-50 my-0' />
                            </div>
                            <Line options={options} data={data} />
                        </div>
                        <div className="col-md-6 h-25">
                            <div className="row py-0 my-0 m-0">
                                <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>Ingreso por Rubro</h5>
                                <hr className='w-50 my-0' />
                            </div>
                            <Bar options={optionss} data={datas} />
                        </div>
                    </div>
                </div>
            </div>

            :  */<TablaPedidos onHideCambio={() => {setVista('panel')}} />
        }
    </div>
  );
}
export default PanelPedidos;


// WEBPACK FOOTER //
// ./src/components/ventas/panelPedidos.js